module.exports = "<section>\n    <section head></section>\n    <div class=\"tablesection\">\n        <div class=\"tablecontainer col-md-12 col-lg-11\">\n            <sev-table uid=\"{{page.tableIdentifiers.id}}\"></sev-table>\n        </div>\n    </div>\n</section>";


/*****************
 ** WEBPACK FOOTER
 ** ./src/pages/views/applications/app_by_l7_resp.html
 ** module id = 582
 ** module chunks = 0
 **/